import secureLocalStorage from "react-secure-storage";
import { USER_STORAGE } from "./storageConfig"
import { TUserInfo } from "../@types/user-info.type";

export function storageUserSave(user: TUserInfo) {
    secureLocalStorage.setItem(USER_STORAGE, JSON.stringify(user))
} 


export function storageUserGet() {
    const storage = secureLocalStorage.getItem(USER_STORAGE)

    const user: TUserInfo = storage ? JSON.parse(storage as string) : {}

    return user
}

export function storageUserRemove() {
    secureLocalStorage.removeItem(USER_STORAGE)
}
